

(function() {
  // Current URL
  const currentURL = window.location.href;

  // Mapping of old URLs to new URLs
  const redirects = {
    "https://configurator.tetrahearing.com/": "https://tetrahearing.com/products/build-my-tetra"
  };

  // Check if the current URL matches any in the redirect list
  if (redirects[currentURL]) {
    // Redirect to the new URL
    window.location.href = redirects[currentURL];
  }
})();
